<div class="ui-app-layout">
<div class="ui-app-layout__sidebar" id="sidebarWrapper">
<aside class="ui-sidebar" [attr.data-expanded]="sidebarExpanded">
  <div class="ui-sidebar__header">
    <div class="ui-sidebar__logo" (click)="toggleSidebar()">
      <img class="ui-sidebar__logo-img" src="logos/light/logo-symbol-color.svg" alt="Wilout" width="32" height="32">
    </div>
    <div class="ui-sidebar__title">CONTROL</div>
    <button class="ui-sidebar__close" (click)="toggleSidebar()" aria-label="Fermer le menu">
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>
  <div class="ui-sidebar__list-info" [class.active]="sidebarExpanded">
    <div class="ui-sidebar__list-name titleEvent"></div>
    <div class="ui-sidebar__list-date titleEventDate"></div>
  </div>
  <nav class="ui-sidebar__nav">
    <ul class="ui-sidebar__menu">
      <!-- Accueil -->
      <li class="ui-sidebar__item" *ngIf="isPageAllowed('tableau-de-bord')">
        <a class="ui-sidebar__link" [class.ui-sidebar__link--active]="isSectionActive('/tableau-de-bord')" (click)="navigateTo('/tableau-de-bord')">
          <span class="ui-sidebar__icon">
            <i [class]="isSectionActive('/tableau-de-bord') ? 'fa-solid fa-house' : 'fa-light fa-house'"></i>
          </span>
          <span class="ui-sidebar__label">Accueil</span>
        </a>
        <div class="ui-sidebar__submenu">
          <div class="ui-sidebar__submenu-header">Accueil</div>
          <a class="ui-sidebar__submenu-link" [class.ui-sidebar__submenu-link--active]="isRouteActive('/tableau-de-bord')" (click)="navigateTo('/tableau-de-bord')">Tableau de bord</a>
        </div>
      </li>
      <!-- Participants -->
      <li class="ui-sidebar__item" *ngIf="isPageAllowed('liste-des-participants')">
        <a class="ui-sidebar__link" [class.ui-sidebar__link--active]="isSectionActive('/liste-des-participants')" (click)="navigateTo('/liste-des-participants')">
          <span class="ui-sidebar__icon">
            <i [class]="isSectionActive('/liste-des-participants') ? 'fa-solid fa-list' : 'fa-light fa-list'"></i>
          </span>
          <span class="ui-sidebar__label">Participants</span>
        </a>
        <div class="ui-sidebar__submenu">
          <div class="ui-sidebar__submenu-header">Participants</div>
          <a class="ui-sidebar__submenu-link" [class.ui-sidebar__submenu-link--active]="isRouteActive('/liste-des-participants')" (click)="navigateTo('/liste-des-participants')">Liste des participants</a>
        </div>
      </li>
      <!-- Configurer -->
      <li class="ui-sidebar__item" *ngIf="isPageAllowed('configurer-general') || isPageAllowed('configurer-ma-liste')">
        <a class="ui-sidebar__link" [class.ui-sidebar__link--active]="isSectionActive('/configurer-general', '/configurer-ma-liste')" (click)="navigateTo('/configurer-general')">
          <span class="ui-sidebar__icon">
            <i [class]="isSectionActive('/configurer-general', '/configurer-ma-liste') ? 'fa-solid fa-hammer' : 'fa-light fa-hammer'"></i>
          </span>
          <span class="ui-sidebar__label">Configurer</span>
        </a>
        <div class="ui-sidebar__submenu">
          <div class="ui-sidebar__submenu-header">Configurer</div>
          <a class="ui-sidebar__submenu-link" [class.ui-sidebar__submenu-link--active]="isRouteActive('/configurer-general')" *ngIf="isPageAllowed('configurer-general')" (click)="navigateTo('/configurer-general')">General</a>
          <a class="ui-sidebar__submenu-link" [class.ui-sidebar__submenu-link--active]="isRouteActive('/configurer-ma-liste')" *ngIf="isPageAllowed('configurer-ma-liste')" (click)="navigateTo('/configurer-ma-liste')">Ma liste</a>
        </div>
      </li>
      <!-- Mes acces (admins only) -->
      <li class="ui-sidebar__item" *ngIf="!isMember">
        <a class="ui-sidebar__link" [class.ui-sidebar__link--active]="isSectionActive('/gerer-les-acces')" (click)="navigateTo('/gerer-les-acces')">
          <span class="ui-sidebar__icon">
            <i [class]="isSectionActive('/gerer-les-acces') ? 'fa-solid fa-arrow-right-from-bracket' : 'fa-light fa-arrow-right-from-bracket'"></i>
          </span>
          <span class="ui-sidebar__label">Mes acces</span>
        </a>
        <div class="ui-sidebar__submenu">
          <div class="ui-sidebar__submenu-header">Points d'acces</div>
          <a class="ui-sidebar__submenu-link" [class.ui-sidebar__submenu-link--active]="isRouteActive('/gerer-les-acces')" (click)="navigateTo('/gerer-les-acces')">Gerer les acces</a>
        </div>
      </li>
      <!-- Mon compte -->
      <li class="ui-sidebar__item">
        <a class="ui-sidebar__link" [class.ui-sidebar__link--active]="isSectionActive('/mes-informations', '/parametres')" (click)="navigateTo('/mes-informations')">
          <span class="ui-sidebar__icon">
            <i [class]="isSectionActive('/mes-informations', '/parametres') ? 'fa-solid fa-id-card-clip' : 'fa-light fa-id-card-clip'"></i>
          </span>
          <span class="ui-sidebar__label">Mon compte</span>
        </a>
        <div class="ui-sidebar__submenu">
          <div class="ui-sidebar__submenu-header">Mon compte</div>
          <a class="ui-sidebar__submenu-link" [class.ui-sidebar__submenu-link--active]="isRouteActive('/mes-informations')" (click)="navigateTo('/mes-informations')">Mes informations</a>
          <a class="ui-sidebar__submenu-link" [class.ui-sidebar__submenu-link--active]="isRouteActive('/parametres')" *ngIf="isPageAllowed('parametres')" (click)="navigateTo('/parametres')">Parametres</a>
        </div>
      </li>
      <!-- Assistance -->
      <li class="ui-sidebar__item">
        <a class="ui-sidebar__link" [class.ui-sidebar__link--active]="isSectionActive('/aide', '/support')" (click)="navigateTo('/aide')">
          <span class="ui-sidebar__icon">
            <i [class]="isSectionActive('/aide', '/support') ? 'fa-solid fa-headset' : 'fa-light fa-headset'"></i>
          </span>
          <span class="ui-sidebar__label">Assistance</span>
        </a>
        <div class="ui-sidebar__submenu">
          <div class="ui-sidebar__submenu-header">Assistance</div>
          <a class="ui-sidebar__submenu-link" [class.ui-sidebar__submenu-link--active]="isRouteActive('/aide')" (click)="navigateTo('/aide')">Aides et astuces</a>
          <a class="ui-sidebar__submenu-link" [class.ui-sidebar__submenu-link--active]="isRouteActive('/support')" (click)="navigateTo('/support')">Support et contacts</a>
        </div>
      </li>
    </ul>
  </nav>
  <!-- Admin footer -->
  <div class="ui-sidebar__footer">
    @if (canImpersonate && !isImpersonating) {
    <button class="ui-sidebar__admin" (click)="onImpersonate()">
      <i class="fas fa-user-secret"></i>
      <span>Espace admin</span>
    </button>
    }
    @if (isImpersonating) {
    <button class="ui-sidebar__admin ui-sidebar__admin--exit" (click)="exitImpersonate()">
      <i class="fas fa-sign-out-alt"></i>
      <span>Quitter l'impersonate</span>
    </button>
    }
  </div>
</aside>
</div>
<div class="ui-sidebar-backdrop" [attr.data-visible]="sidebarExpanded" (click)="toggleSidebar()"></div>
<div class="ui-app-layout__main">
<div class="headerbo ui-app-header">
  <div class="testtt" (click)="toggleSidebar()" role="button" tabindex="0" aria-label="Ouvrir le menu">
    <img class="logowilout0" src="logos/dark/logo-symbol-color.svg" alt="Wilout" width="32" height="32">
  </div>
  <div class="desec ui-app-header__breadcrumb">
    <span id="htitsec"></span><span id="fles"> &nbsp; <i
        style="transform: scale(0.9)" class="fas fa-chevron-right"></i> &nbsp; </span><span
      id="htitsec2" class="ui-app-header__breadcrumb-item--active"></span>
  </div>
  <div class="ui-app-header__actions">
    @if (isImpersonating) {
    <div class="impersonate-chip">
      <i class="fas fa-user-secret"></i>
      <span class="impersonate-chip__name">{{ impersonatedOrganizerName }}</span>
      <button class="impersonate-chip__close" (click)="exitImpersonate()" title="Quitter le mode impersonate"><i class="fas fa-sign-out-alt"></i></button>
    </div>
    }
    <div class="multievbtn ui-btn ui-btn--secondary ui-btn--sm ui-btn--auto" (click)="openMesListes()">
      <i class="fal fa-bars"></i><span class="btnlabel"> &nbsp; Mes listes de contrôle</span>
    </div>
    <div class="addevbtn ui-btn ui-btn--secondary ui-btn--sm ui-btn--auto">
      <i class="fal fa-plus"></i><span class="btnlabel"> &nbsp; Nouvelle liste</span>
    </div>
    <div class="decobtn">
      <i class="fa-regular fa-right-from-bracket"></i>
    </div>
  </div>
</div>
<div class="messError">
  <div class="txtError">
    <span style="font-weight:800;font-size: 26px"><i class="far fa-frown"></i> &nbsp;Oups...</span>&nbsp; <span
      class="txer2"><br><br></span><span style="font-weight:800;font-size: 18px">Une erreur est surevenue,<span
        class="txer1"><br></span> veuillez réessayer.</span>
    <br><br><br>
    <span style="font-weight:400;font-size: 15px">Si le problème persiste,<span class="txer1"><br></span> veuillez <span
        routerLink="/support" style="font-weight:800;text-decoration:underline;cursor:pointer;">contacter notre
        support</span>.</span>
  </div>
</div>
<div class="bloCont ui-app-layout__content">
  <router-outlet>

  </router-outlet>
</div>
</div><!-- /ui-app-layout__main -->
</div><!-- /ui-app-layout -->
<app-mes-listes-controle *ngIf="mesListesOpen" (closed)="mesListesOpen = false"></app-mes-listes-controle>
<div class="blocaddevent">
  <div class="headae">
    <span style="display:inline-block;margin-left:50px"><i class="fal fa-plus"></i> &nbsp;Créer une nouvelle liste de
      contrôle</span>
    <span class="closepopadevent"><i class="far fa-times"></i></span>
  </div>
  <div class="contblocae">
    <div class="liformae">
      <div class="labelae">
        <i class="fa-duotone fa-light fa-input-text icduotone"></i> &nbsp;Nom de la liste
      </div>
      <input type="text" class="inae" id="innameAE" placeholder="Titre">
    </div>
    <div class="liformae">
      <div class="labelae">
        <i class="fa-duotone fa-light fa-calendar icduotone"></i> &nbsp;Date de fin de validité de la liste
      </div>
      <input class="inae" id="indateAE" type="datetime-local">
    </div>
  </div>
  <div class="bottomae">
    <div class="btnconfaddevent ui-btn ui-btn--primary">
      <span class="labelconfaddevent"><i class="fas fa-save"></i> &nbsp;Enregistrer</span>
      <div class="loaderaddevent"></div>
    </div>
  </div>
</div>
<div class="bloconfdeco">
  <div class="headedit">
    Êtes-vous sûr de vouloir vous déconnecter ?
  </div>
  <div class="textconfdeco">
    <i class="fal fa-info-circle" style="font-size:40px"></i>
    <br><br>
    Pour poursuivre et vous déconnecter
    <br>
    veuillez cliquer sur le bouton ci-dessous
  </div>
  <div class="btnconfdeco">Confirmer</div>
</div>
<div class="fdpop">

</div>
<div class="fdpopstop">
  <div class="decobtn2">
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 529.286 529.286"
      width="21px" height="21px" style="enable-background:new 0 0 529.286 529.286;" xml:space="preserve">
      <g>
        <g>
          <path d="M358.099,74.604c0,0-28.097-12.644-28.097,16.896s27.837,49.363,28.19,49.3c49.147,32.081,81.629,87.559,81.629,150.629
                            c0,97.746-78.016,177.269-175.177,179.7c-97.161-2.431-175.177-81.954-175.177-179.7c0-63.071,32.483-118.547,81.629-150.629
                            c0.353,0.063,28.189-19.761,28.189-49.3s-28.097-16.896-28.097-16.896C88.7,111.958,31.31,194.983,31.31,291.429
                            c0,129.865,104.053,235.413,233.334,237.857c129.281-2.445,233.332-107.992,233.332-237.857
                            C497.977,194.983,440.587,111.958,358.099,74.604z" />
          <path d="M266.278,0c-26.143,0-34.312,19.141-34.312,26.627v117.159v117.159c0,7.487,8.17,26.627,34.312,26.627
                            c26.143,0,31.045-19.141,31.045-26.627V143.786V26.627C297.322,19.14,292.421,0,266.278,0z" />
        </g>
      </g>
    </svg>
  </div>
</div>
<div class="blocLoader">
  <div class="contenuLoader">
    <svg xmlns="http://www.w3.org/2000/svg" style="filter: drop-shadow(0px 4px 3px #00be9e5d);" width="250px"
      height="250px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <defs>
        <linearGradient id="bc1" x1="70%" y1="80%" x2="0%" y2="0%"><stop offset="0%" style="stop-color: #00be9e"></stop><stop offset="80%" style="stop-color: #00e0af"></stop></linearGradient>
      </defs>
      <circle cx="60.2164" cy="60.2164" r="6.71671" fill="url(#bc1)">
        <animate attributeName="cx" values="62.020815280171306;37.97918471982869;62.020815280171306" keyTimes="0;0.5;1"
          dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
          begin="0.6535947712418301s"></animate>
        <animate attributeName="cy" values="62.020815280171306;37.979184719828694;62.020815280171306" keyTimes="0;0.5;1"
          dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
          begin="0.6535947712418301s"></animate>
        <animate attributeName="r" values="9;1.8;9;1.8;9" keyTimes="0;0.25;0.5;0.75;1" dur="1.9607843137254901s"
          repeatCount="indefinite" begin="0.6535947712418301s"></animate>
      </circle>
      <circle cx="46.3863" cy="63.4865" r="6.4833" fill="url(#bc1)">
        <animate attributeName="cx" values="45.60007623325715;54.399923766742845;45.60007623325715" keyTimes="0;0.5;1"
          dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
          begin="0.32679738562091504s"></animate>
        <animate attributeName="cy" values="66.42073904691416;33.579260953085836;66.42073904691416" keyTimes="0;0.5;1"
          dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
          begin="0.32679738562091504s"></animate>
        <animate attributeName="r" values="9;1.8;9;1.8;9" keyTimes="0;0.25;0.5;0.75;1" dur="1.9607843137254901s"
          repeatCount="indefinite" begin="0.32679738562091504s"></animate>
      </circle>
      <circle cx="50.3802" cy="49.8981" r="1.9167" fill="url(#bc1)">
        <animate attributeName="cx" values="33.579260953085836;66.42073904691416;33.579260953085836" keyTimes="0;0.5;1"
          dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
          begin="0s"></animate>
        <animate attributeName="cy" values="54.39992376674286;45.60007623325715;54.39992376674286" keyTimes="0;0.5;1"
          dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
          begin="0s"></animate>
        <animate attributeName="r" values="9;1.8;9;1.8;9" keyTimes="0;0.25;0.5;0.75;1" dur="1.9607843137254901s"
          repeatCount="indefinite" begin="0s"></animate>
      </circle>
    </svg>
    <br><br>
    Chargement des données ...
  </div>
</div>
<div class="savestick">
  <svg xmlns="http://www.w3.org/2000/svg"
    style="margin-top:-18px;margin-left:-12px;filter: drop-shadow(0px 6px 6px rgba(0, 47, 54, 0.4));opacity:.9"
    width="85px" height="85px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
    <defs>
      <linearGradient id="bc2" x1="70%" y1="80%" x2="0%" y2="0%">
        <stop offset="0%" style="stop-color:#ffffff;"></stop>
        <stop offset="80%" style="stop-color:#ffffff;"></stop>
      </linearGradient>
    </defs>
    <circle cx="60.2164" cy="60.2164" r="6.71671" fill="url(#bc2)">
      <animate attributeName="cx" values="62.020815280171306;37.97918471982869;62.020815280171306" keyTimes="0;0.5;1"
        dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
        begin="0.6535947712418301s"></animate>
      <animate attributeName="cy" values="62.020815280171306;37.979184719828694;62.020815280171306" keyTimes="0;0.5;1"
        dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
        begin="0.6535947712418301s"></animate>
      <animate attributeName="r" values="9;1.8;9;1.8;9" keyTimes="0;0.25;0.5;0.75;1" dur="1.9607843137254901s"
        repeatCount="indefinite" begin="0.6535947712418301s"></animate>
    </circle>
    <circle cx="46.3863" cy="63.4865" r="6.4833" fill="url(#bc2)">
      <animate attributeName="cx" values="45.60007623325715;54.399923766742845;45.60007623325715" keyTimes="0;0.5;1"
        dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
        begin="0.32679738562091504s"></animate>
      <animate attributeName="cy" values="66.42073904691416;33.579260953085836;66.42073904691416" keyTimes="0;0.5;1"
        dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
        begin="0.32679738562091504s"></animate>
      <animate attributeName="r" values="9;1.8;9;1.8;9" keyTimes="0;0.25;0.5;0.75;1" dur="1.9607843137254901s"
        repeatCount="indefinite" begin="0.32679738562091504s"></animate>
    </circle>
    <circle cx="50.3802" cy="49.8981" r="1.9167" fill="url(#bc2)">
      <animate attributeName="cx" values="33.579260953085836;66.42073904691416;33.579260953085836" keyTimes="0;0.5;1"
        dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
        begin="0s"></animate>
      <animate attributeName="cy" values="54.39992376674286;45.60007623325715;54.39992376674286" keyTimes="0;0.5;1"
        dur="1.9607843137254901s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" repeatCount="indefinite"
        begin="0s"></animate>
      <animate attributeName="r" values="9;1.8;9;1.8;9" keyTimes="0;0.25;0.5;0.75;1" dur="1.9607843137254901s"
        repeatCount="indefinite" begin="0s"></animate>
    </circle>
  </svg>
  <div style="float: right;line-height: 50px;transform: translateX(-28px);">&nbsp; Sauvegarde en cours...</div>
</div>